module.exports = __webpack_public_path__ + "img/zeus_full.9620ef33.svg";